import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import moment from 'moment'
import { makeStyles } from '@material-ui/styles'
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText
} from '@material-ui/core'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import PaymentIcon from '@material-ui/icons/Payment'
import PeopleIcon from '@material-ui/icons/PeopleOutlined'
import StoreIcon from '@material-ui/icons/Store'
import AlarmAddIcon from '@material-ui/icons/AlarmAdd'
import BuildOutlinedIcon from '@material-ui/icons/BuildOutlined'

import gradients from 'src/utils/gradients'

const useStyles = makeStyles(theme => ({
  root: {},
  listItem: {
    '&:hover': {
      backgroundColor: theme.palette.background.default
    }
  },
  avatarBlue: {
    backgroundImage: gradients.blue
  },
  avatarGreen: {
    backgroundImage: gradients.green
  },
  avatarOrange: {
    backgroundImage: gradients.orange
  },
  avatarIndigo: {
    backgroundImage: gradients.indigo
  },
  avatarRed: {
    backgroundImage: gradients.red
  },
  arrowForwardIcon: {
    color: theme.palette.icon
  }
}))

const NotificationList = props => {
  const { notifications, className, ...rest } = props

  const classes = useStyles()

  const avatars = {
    order: (
      <Avatar className={classes.avatarBlue}>
        <PaymentIcon />
      </Avatar>
    ),
    user: (
      <Avatar className={classes.avatarOrange}>
        <PeopleIcon />
      </Avatar>
    ),
    project: (
      <Avatar className={classes.avatarGreen}>
        <StoreIcon />
      </Avatar>
    ),
    feature: (
      <Avatar className={classes.avatarGreen}>
        <AlarmAddIcon />
      </Avatar>
    ),
    maintenance: (
      <Avatar className={classes.avatarOrange}>
        <BuildOutlinedIcon />
      </Avatar>
    )
  }

  return (
    <List
      {...rest}
      className={clsx(classes.root, className)}
      disablePadding
    >
      {notifications.map((notification, i) => (
        <ListItem
          className={notification.link ? classes.listItem : undefined}
          component={notification.link ? RouterLink : 'div'}
          divider={i < notifications.length - 1}
          key={notification.id}
          {...(notification.link ? { to: notification.link } : {})}
        >
          <ListItemAvatar>{avatars[notification.type]}</ListItemAvatar>
          <ListItemText
            primary={notification.title}
            primaryTypographyProps={{ variant: 'body1' }}
            secondary={notification.subtitle || moment(notification.created_at).fromNow()}
          />
          {notification.link ? <ArrowForwardIcon className={classes.arrowForwardIcon} /> : null}
        </ListItem>
      ))}
    </List>
  )
}

NotificationList.propTypes = {
  className: PropTypes.string,
  notifications: PropTypes.array.isRequired
}

export default NotificationList
